import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import EditOutlineIcon from '@mui/icons-material/EditOutlined'

export const DeleteIcon = DeleteOutlineIcon
export const EditIcon = EditOutlineIcon
